<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>传真</li>
                <li><a href="#">传真审核列表</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">            
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="20%">号码</th>
                    <th width="25%">标题</th>
                    <th width="25%">传真文件</th>
                    <th width="10%">提交时间</th>
                    <th width="10%">状态</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in faxCheckList" :class="{odd:index%2!=0}">
                    <td width="20%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-if="item.format=='txt'" title="点击下载文件">号码文件：{{item.txtfilesrcname}}<br/></td>
                    <td width="20%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.faxnum" v-else>
                        {{item.faxnum}}
                    </td>
                    <td width="25%" >{{item.title}}</td>
                    <td width="25%" :title="item.txtfilesrcname">{{item.faxfilesrcname}}</td>
                    <td width="10%" :title="item.createTime">{{item.createTime}}</td>
                    <td width="10%" :title="item.demo">
                        <ol v-if="item.state == 0">未审核</ol>
                        <ol v-else-if="item.state == 1">审核通过</ol>
                        <ol style="color:red" v-else-if="item.state == -1">审核不通过<br/>{{item.demo}}<br/>
                            <!-- <a target="_blank" href="//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf"><img border="0" src="//wpa.qq.com/pa?p=2:800020214:41" alt="点击咨询" title="点击咨询"/></a> -->
                        </ol>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            faxCheckList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val){
            this.pageChange(val);
        },
        handleCurrentChange(val){
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageSize':50,pageIndex:pageIndex,state:100};
            //console.log(JSON.stringify(data));
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/fax/getpagefaxcheck.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.faxCheckList = res.data.faxCheckList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        download(id){
            window.open(this.GLOBAL.serverSrc + "/sms/downloadsmsblackcontenttxt.json?token=" + this.GLOBAL.token + "&id=" + id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/fax/faxcheck.vue